export class FlowRunAction {
    //_id: string;
    runName?:string;
    name: string;
    startTime: Date;
    endTime: Date;
    status: string;
    code: string;
    inputsLink: string;
    outputsLink: string;
    error: any;
    raw: any;
    type: string = "action";    

    constructor(init?: any){
        if (init) {
            this.initialize(init);
        }
    }

    initialize(item: any) {
        if (item.properties) {
            // via run-api
            //this._id = this.name = item.name;
            // this.flowName = item.properties.object.flowName;
            this.runName = item.runName;
            this.name = item.name;
            this.status = item.properties.status;
            this.code = item.properties.code;
            this.startTime = item.properties.startTime ? new Date(item.properties.startTime) : null;
            this.endTime = item.properties.endTime? new Date(item.properties.endTime): null;
            this.error = item.properties.error;
            this.raw = item;
            this.inputsLink = item.properties.inputsLink ? item.properties.inputsLink.uri : null;
            this.outputsLink = item.properties.outputsLink ? item.properties.outputsLink.uri : null;
            return;
        }
        else {
            this.runName = item.runName;
            this.name = item.name;
            this.status = item.status;
            this.code = item.code;
            this.startTime = item.startTime ? new Date(item.startTime) : null;
            this.endTime = item.endTime? new Date(item.endTime): null;
            this.error = item.error;
            this.raw = item;
            this.inputsLink = item.inputsLink ? item.inputsLink.uri : null;
            this.outputsLink = item.outputsLink ? item.outputsLink.uri : null;
        }
    }

    get duration(){
        return this.endTime ? this.endTime.getTime() - this.startTime.getTime() : null;
    }

    get durationString() {
        var diff = this.duration;
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff -=  days * (1000 * 60 * 60 * 24);
        
        var hours = Math.floor(diff / (1000 * 60 * 60));
        diff -= hours * (1000 * 60 * 60);
        
        var mins = Math.floor(diff / (1000 * 60));
        diff -= mins * (1000 * 60);
        
        var seconds = diff/1000;// Math.floor(diff / (1000));
        //diff -= seconds * (1000);

        var results = [];
        if (days) results.push(`${days}d`);
        if (hours) results.push(`${hours}h`);
        if (mins) results.push(`${mins}m`);
        if (seconds || results.length === 0) results.push(`${seconds}s`);
        //if (diff) results.push(`${diff}ms`);
        return results.join(' ');
        //document.write(days + " days, " + hours + " hours, " + mins + " minutes, " + seconds + " seconds");        
    }

    get actions() : string[] {
        var actions = [];
        actions.push('Export Excel');
        return actions;
    }

}